import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirstStageService {
  private hostUrl: string;

  constructor(private http: HttpClient) {
    this.hostUrl = environment.host;
  }
  // private createCandidateApplicationUrl = 'https://recruitmentproxytest.ameriabank.am/api/Candidate/CreateCandidateApplication';
  // private getPageUpdateDateUrl = 'https://recruitmentproxytest.ameriabank.am/api/Common/GetPageUpdateDate';

  addEmployee(employee: any): Observable<any> {
    return this.http.post(`${this.hostUrl}/Candidate/CreateCandidateApplication`, employee);
  }

  getPageUpdateDate(id): Observable<any> {
    return this.http.get(`${this.hostUrl}/Common/GetPageUpdateDate?id=${id}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }
}
